import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Package, Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const { handleGoogleCallback } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/login');
        return;
      }

      try {
        const result = await handleGoogleCallback(sessionId);
        // Redirect based on role
        if (result.user.role === 'admin' || result.user.role === 'super_admin') {
          navigate('/admin/dashboard', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processCallback();
  }, [handleGoogleCallback, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center" data-testid="auth-callback">
      <img src="/cargodash-logo.svg" alt="CargoDash" className="h-12 mb-4" />
      <Loader2 className="h-8 w-8 text-teal-600 animate-spin mb-4" />
      <p className="text-slate-600">Completing sign in...</p>
    </div>
  );
};

export default AuthCallback;
